// Lib
import React from 'react';

import PropTypes from 'prop-types';

// Components
import BoardImagePickerContainer from './BoardImagePickerContainer';

// Styles
import './IconTabContentImagePicker.scss';
import { useTranslator } from '../../../../../../../../components/i18n/useTranslator';

const IconTabContentImagePicker = (props) => {
    const translate = useTranslator('popup', 'icon.imagePicker');

    return (
        <div className="IconTabContentImagePicker">
            <BoardImagePickerContainer {...props} />
            <div className="instructions">
                {translate('imageSizeTip')}
            </div>
        </div>
    );
};

IconTabContentImagePicker.propTypes = {
    gridSize: PropTypes.number.isRequired,
    selectedElements: PropTypes.object.isRequired,
    dispatchBoardImage: PropTypes.func,
};

export default IconTabContentImagePicker;
